 import * as constants from './constants';
 import userRequest, {
     userApi
 } from 'common/request';
 const changeCourseInfoList = (infoList) => ({
     type: constants.CHANGE_COURSEPROJECT_LIST_DATA,
     infoList
 });
 export const changeCourseInfo = (info) => ({
     type: constants.CHANGE_COURSEPROJECT_DATA,
     info
 });
 const changeExcellentList = (excellentList) => ({
     type: constants.CHANGE_EXCELLENT_LIST,
     excellentList
 })
 const changeAttachmentList = (attachmentList) => ({
     type: constants.CHANGE_ATTACHMENT_LIST,
     attachmentList
 })
 const changeCollect = (collect) => ({
     type: constants.CHANGE_COLLECT,
     collect
 })
 const getFinishedList = (finishedList) => ({
   type: constants.CHANGE_FINISHED,
   finishedList
 })
 const getFinishedListLock = (finishedListLock) => ({
    type: constants.CHANGE_FINISHED_LOCK,
    finishedListLock
  })
const getLastCourse = (lastCourseId) => ({
    type: constants.CHANGE_LASTCOURSE,
    lastCourseId
})
 const evil = (fn) => {

     var Fn = Function; //一个变量指向Function，防止有些前端编译工具报错
     return new Fn('return ' + fn)();
 }
 export const getCourseInfo = (course_id) => {
     return  async (dispatch) => {
        await userRequest.get(window.AppConfig.mainIP + userApi.courseDetail, {
             course_id
         }).then( (res) => {
             if (res.code === 0) {
                 //获取优秀作品
                 dispatch(getCourseExcellent(course_id, res.data.subject))
                 dispatch(changeCourseInfoList(res.data))
                 dispatch(changeCourseInfo(res.data))
                 dispatch(getSubjectMembers(course_id))

                  if (res.data.attachments) {

                   let attachments ={}
                    try
                      {
                      //在这里运行代码
                         attachments = JSON.parse(res.data.attachments);
                      }
                    catch(err)
                      {
                      //在这里处理错误
                        attachments ={}
                      }
                      dispatch(changeAttachmentList(attachments));

                 }

                 localStorage.setItem("courseSubject", JSON.stringify(res.data.subject));
                 localStorage.setItem("courseid", JSON.stringify(res.data.id));
                 localStorage.setItem("information_data", JSON.stringify(res.data.information_data))
             }
         })
     }
}

export const getSubjectMembers = (course_id) => {
    if(localStorage.getItem('userinfo') !== null){
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))
    const search = {usernames: [userinfo.user_name]}
    const params = {
        isscore: 0,
        isprogress: 1,
        search: JSON.stringify(search)
    }
    return async (dispatch, getState) => {

        await userRequest.get(`${window.AppConfig.mainIP}${userApi.subjectMembers}/${course_id}`, params).then(res => {
            const courseprojectInfo = getState().toJS().courseproject.info
            const subjectMembers = res.data&&res.data.data || []
            courseSubjectHandle(courseprojectInfo.subject, subjectMembers[0]&&subjectMembers[0].Subject||[])

            // console.log('------------------------------------------getState', getState())
            // console.log('------------------------------------------subjectMembers', subjectMembers)
            // console.log('------------------------------------------courseprojectInfo', courseprojectInfo)

            dispatch(changeCourseInfo(courseprojectInfo))
            localStorage.setItem("courseSubject", JSON.stringify(courseprojectInfo.subject));
        })
    }
    }
}

const courseSubjectHandle = (courseList, learnList) => {
    for (let item of courseList) {
        const learnItem = learnList.find(value => item.id == value.SubId)
        if (learnItem) {
            item.Duration = learnItem.Duration
            item.DurationStr = `${parseInt(learnItem.Duration/60)>9?parseInt(learnItem.Duration/60):'0'+parseInt(learnItem.Duration/60)}:${parseInt(learnItem.Duration%60)>9?parseInt(learnItem.Duration%60):'0'+parseInt(learnItem.Duration%60)}`
            item.LearnTime = learnItem.LearnTime
            item.LearnTimeStr = `${parseInt(learnItem.LearnTime/60)>9?parseInt(learnItem.LearnTime/60):'0'+parseInt(learnItem.LearnTime/60)}:${parseInt(learnItem.LearnTime%60)>9?parseInt(learnItem.LearnTime%60):'0'+parseInt(learnItem.LearnTime%60)}`
        }
        if (item.childs) courseSubjectHandle(item.childs,learnList)
    }
}

// 查看课程章节是否已学过
export const getFinishedCourse = (course_id, user_id) => {
   return async(dispatch) => {
    await userRequest.get(window.AppConfig.mainIP + userApi.courseListFinished, {
       "type": "learned", "get_sub_list":"1", course_id, user_id
     }).then((res) => {
       if (res.success === true && res.result.data.length > 0) {
         dispatch(getFinishedList(res.result.data))
       }
     })

    await userRequest.get(window.AppConfig.mainIP + userApi.courseListFinished, {
      "type": "learn", "sort_update_desc": "1","user_id": user_id, course_id
    }).then((res) => {
      console.log(res)
      if (res.success === true && res.result.data.length > 0) {
        dispatch(getLastCourse(res.result.data[0].course_subject_id))
      }else {
        dispatch(getLastCourse(''))
      }}).catch(err => console.log(err))
   }
}

// 后面的修改，查看章节是否学过然后是否解锁
export const getFinishedCourseLock = (course_id, account) => {
    let tid = JSON.parse(localStorage.getItem('userinfo')).tenant
    return (dispatch) => {
      userRequest.get(window.AppConfig.mainIP + userApi.courseListFinishedLock + course_id, {
          "tid": tid, "username": account
      }).then((res) => {
        if (res.code === 200 && res.data.data.length > 0) {
            dispatch(getFinishedListLock(res.data.data))
        }
      })
    }
 }


export const getCourseWatched=(course_id) =>{
     return (dispatch)=>{
         userRequest.get(window.AppConfig.mainIP+userApi.getCourseWatch+`${course_id}`).then((res)=>{})
     }
};
 //优秀作品
 //
 export const getCourseExcellent = (course_id, subject) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getCourseExcellent, {
             course_id
         }).then((res) => {
             if (res.code === 0 && res.data.length !== 0 && subject.length !== 0) {
                 res.data.map((item, index) => {
                     // let courseSubject = JSON.parse(localStorage.getItem("courseSubject"));
                     console.log(item, 'this is item')
                     let courseSubject = subject;
                     courseSubject.map((chapter, i) => {
                         chapter.childs.map((childs, j) => {
                             childs.childs.map((sub, s) => {
                                 if (item.course_subject_id === sub.id) {
                                     let tag = '';
                                     let type = sub.content.type
                                     if (type === 'video') {
                                         tag = '[视频课]';
                                     } else if (type === 'exam') {
                                         tag = '[随堂测试]';
                                     } else {
                                         tag = '[实验课]';
                                     }
                                     let subtitle = (j + 1) + '.' + (s + 1) + tag + sub.title || sub.title;
                                     item.subtitle = subtitle
                                 }
                             })
                         })
                     })
                 })
                 console.log(res.data + 'dwdwdwdwd');
                 dispatch(changeExcellentList(res.data));
                 // let mark = res.data[0].mark;
                 // let content = res.data[0].content;
                 // console.log(evil(mark),evil(content))
             }
         })
     }
 }


 //查询是否收藏
 export const getRecord = (course_id, user_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getRecord, {
             type: 'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                 if (res.data.models && res.data.models.length !== 0) {
                     dispatch(changeCollect(true))
                 } else {
                     dispatch(changeCollect(false))
                 }
             }
         })
     }
 }
 //添加收藏 addRecord
 export const addRecord = (course_id, user_id) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.mainIP + userApi.addRecord, {
             type: 'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                 dispatch(changeCollect(true))
                 console.log('addRecord', res)
             }
         })
     }
 }
 //删除收藏 delRecord
 export const delRecord = (course_id, user_id) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.mainIP + userApi.delRecord, {
             type: 'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                 console.log('delRecord', res)
                 dispatch(changeCollect(false))
             }
         })
     }
 }


